/**
 * 校验外壳二维码 (16位16进制)
 * @param {string} input
 * @returns {{eui: string, isValid: boolean}}
 */
export function validateShellDeviceEUI(input = "") {
  if (!input) return { isValid: false, eui: "" };
  const extractedEUI = input.trim().toUpperCase();
  const isValid = /^[0-9A-F]{16}$/.test(extractedEUI);
  return {
    eui: extractedEUI,
    isValid: isValid,
  };
}

/**
 * 校验板子二维码 (可能带前缀)
 * @param {string} input
 * @returns {{eui: string, isValid: boolean}}
 */
export function validateBoardDeviceEUI(input = "") {
  const rawInput = input.trim().toUpperCase();
  let extractedEUI = null;

  const euiMatch = rawInput.match(/EUI[：:]([0-9A-F]{16})/i);
  if (euiMatch && euiMatch[1]) {
    extractedEUI = euiMatch[1];
  }

  const isValid = extractedEUI !== null && /^[0-9A-F]{16}$/.test(extractedEUI);
  return {
    eui: extractedEUI,
    isValid: isValid,
  };
}

/**
 * 校验标签类型
 * @param {string} tag
 * @returns {string} - "HF", "UHF", or ""
 */
export function getTagType(tag = "") {
  const hfPattern1 = /^([0-9A-F]{2}:){7}[0-9A-F]{2}$/i;
  const uhfPattern = /^[0-9A-Z]{24}$/i;

  if (hfPattern1.test(tag)) return "HF";
  if (uhfPattern.test(tag)) return "UHF";
  return "";
}
